module.exports = __webpack_public_path__ + "img/calendarIL1.03a3f34d.jpg";